import React, { useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { skills } from "../data/data";
import { GiSkills } from "react-icons/gi";
import "./Skills.css";

const Skills = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? skills.length - 1 : currentSlide - 1);
  };

  const nextSlide = () => {
    setCurrentSlide(currentSlide === skills.length - 1 ? 0 : currentSlide + 1);
  };

  const renderSlides = () => {
    const slides = [];
    for (let i = currentSlide; i < currentSlide + 3; i++) {
      const index = i % skills.length;
      slides.push(
        <Col key={skills[index].name} xs={10} sm={6} md={4} lg={4}>
          <div
            className={`skill-card ${
              i === currentSlide
                ? "slide-in-left"
                : i === currentSlide + 1
                ? "slide-in-middle"
                : "slide-in-right"
            }`}
          >
            <Image
              src={skills[index].image}
              fluid
              className="skill-card-image"
            />
            <div className="skill-card-body">
              <h4 className="skill-card-title">{skills[index].name}</h4>
            </div>
          </div>
        </Col>
      );
    }
    return slides;
  };

  return (
    <Container className="mt-5">
      <div className="d-flex align-items-center justify-content-center mb-4">
        <h2 className="text-center mr-2">My </h2>
        <GiSkills size={50} className="skill-icon" />
        <h2 className="text-center ml-2">Skills</h2>
      </div>
      <Row className="justify-content-center">
        {renderSlides()}
      </Row>
      <div className="d-flex justify-content-center mt-4">
        <Button variant="primary" className="s-btn mr-3" onClick={prevSlide}>
          <FaChevronLeft />
        </Button>
        <Button variant="primary" className="s-btn" onClick={nextSlide}>
          <FaChevronRight />
        </Button>
      </div>
    </Container>
  );
};

export default Skills;
